<template>
  <div class="wt-dialog-container">
    <div v-loading="isDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm">
        <template slot="level" slot-scope="scope">
          <el-select v-model="detailFormData.level" :placeholder="scope.item.disabled ? '' : '请选择' + scope.item.name" :disabled="scope.item.disabled" @change="levelChange">
            <el-option v-for="(dataItem, dataIndex) in scope.item.data" :key="dataIndex" :label="dataItem.label"
                       :value="dataItem.value"></el-option>
          </el-select>
        </template>
        <template slot="parentid" slot-scope="scope">
          <el-form-item v-if="detailFormData.level !== 1" :label="scope.item.name + '：'" :prop="scope.item.key" :rules="scope.item.rules" :class="scope.item.className ? scope.item.className : 'wt-col-12'">
            <el-select v-model="detailFormData.parentid" filterable :placeholder="scope.item.disabled ? '' : '请选择' + scope.item.name" :disabled="scope.item.disabled">
              <el-option v-for="(dataItem, dataIndex) in scope.item.data" :key="dataIndex" :label="dataItem.label"
                         :value="dataItem.value"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </wt-detail-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteOrganizationEditPage',
  props: ['component-type', 'detailData'],
  isAutoComponent: true,
  data() {
    return {
      isDetailLoading: false, // 加载
      isSubmitLoading: false, // 提交
      detailForm: {
        title: '新增机构',
        className: 'wt-section-long-content',
        elements: [
          { name: '结构层级',
            key: 'level',
            type: 'custom',
            required: true,
            disabled: true,
            data: [
              { label: '总公司', value: 1 },
              { label: '分公司', value: 2 },
              { label: '项目部', value: 3 }
            ] },
          { name: '上级机构名称',
            key: 'parentid',
            type: 'customAll',
            required: true,
            disabled: true,
            data: [],
            rules: [{ required: true, message: '请选择上级机构名称', trigger: 'change' }] },
          { name: '机构名称',
            key: 'name',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { validator: this.$wtValidator.ValidatorNotBlank, message: '机构名称不能为空', trigger: 'blur' }
            ] }]
      },
      detailFormButtons: {
        title: '',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailFormData: {
        level: 1,
        parentid: '',
        name: ''
      }
    }
  },
  created() {
    if (this.componentType === 'edit') {
      this.detailForm.title = '编辑机构'
      this.orgDetails()
    } else {
      this.detailFormData = Object.assign(this.detailFormData, this.detailData)
      this.orgListSelect()
    }
  },
  methods: {
    levelChange() {
      this.detailFormData.parentid = ''
      this.orgListSelect()
    },
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAdd()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdate()
      }).catch(() => {
      })
    },
    requestAdd() {
      const that = this
      this.isSubmitLoading = true
      this.$api.siteManage.org.orgAdd(this.detailFormData).then(res => {
        that.isSubmitLoading = false
        that.requestSuccess()
      }).catch(() => {
        that.isSubmitLoading = false
      })
    },
    requestUpdate() {
      const that = this
      this.isSubmitLoading = true
      this.$api.siteManage.org.orgUpdate(this.detailFormData).then(res => {
        that.isSubmitLoading = false
        that.requestSuccess()
      }).catch(() => {
        that.isSubmitLoading = false
      })
    },
    requestSuccess() {
      this.$message({ message: '保存成功', type: 'success' })
      this.$emit('on-dialog-action', 'close')
      this.$emit('on-dialog-action', 'refresh')
    },
    orgListSelect() {
      const ele = this.detailForm.elements.find(item => { return item.key === 'parentid' })
      ele.data = []
      if (this.detailFormData.level === 1) {
        return
      }
      this.$api.siteManage.org.orgListSelect({
        level: this.detailFormData.level - 1
      }).then(res => {
        for (const item of res.data) {
          item.label = item.name
          item.value = item.id
        }
        ele.data = res.data
      })
    },
    orgDetails() {
      this.$api.siteManage.org.orgDetails({
        id: this.detailData.id
      }).then(res => {
        this.detailFormData = res.data
        this.orgListSelect()
      })
    }
  }
}
</script>
